module.exports = __webpack_public_path__ + "img/product15.fecf8e5a.png";